import { render, staticRenderFns } from "./CustomilyProductsList.vue?vue&type=template&id=e309a20a&scoped=true"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./CustomilyProductsList.vue?vue&type=style&index=0&id=e309a20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e309a20a",
  null
  
)

export default component.exports